module.exports = "/_next/static/images/ff27e3762796e050dff143fe6a36a9db-ticket-01-01.png.webp";